import { z } from 'zod';
/**
 * `GET /api/v1/organizations/:organizationId/health` (KIR-3747).
 *
 * The canary for the public surface: it proves a customer's key authenticated,
 * resolved to the right tenant, and was attributed to the right creator —
 * without exposing any org data. It is what a customer curls first, and what a
 * connector's setup screen calls to validate credentials.
 *
 * `userId` is the local id of whoever minted the key, which is also the actor
 * every write made with it will be attributed to (design D2). `apiKeyId` is the
 * Descope access-key id, so a customer holding several keys can tell which one
 * a given credential is.
 */
export const v1HealthResponseSchema = z
    .object({
    ok: z
        .literal(true)
        .describe('Always `true`. A failing credential answers 401 or 403 instead.'),
    organizationId: z
        .string()
        .describe('The organization this key is scoped to. The only one it can read.'),
    userId: z
        .string()
        .describe('Kirin user id of whoever created the key. Every write made with it is attributed to this person.'),
    apiKeyId: z
        .string()
        .describe('Id of the key that authenticated this request. Use it to tell which of several keys a credential is.'),
})
    .meta({
    id: 'V1Health',
    title: 'Health',
    description: 'What the presented credential resolved to. Reads no organization data.',
    examples: [
        {
            ok: true,
            organizationId: '3f9a1b64-2c8e-4d17-9b05-1e7c4a6d2f88',
            userId: 'u_2Nk8QpXyZ',
            apiKeyId: 'K2b9c1d4e6f8a0',
        },
    ],
});
//# sourceMappingURL=health.js.map